document.addEventListener("DOMContentLoaded", function () {
  const insuranceCheckbox = document.getElementById("add-insurance");
  const insuranceProductId = 48469609611555; // Replace with the actual product variant ID
  if (insuranceCheckbox) {
    const getInsurance = localStorage.getItem("CheckInsurance");
    if (getInsurance == "true") {
      $("#add-insurance").attr("checked", true);
    } else {
      $("#add-insurance").attr("checked", false);
    }
    console.log(getInsurance, "getInsurance");
    insuranceCheckbox.addEventListener("change", function () {
      if (this.checked) {
        localStorage.setItem("CheckInsurance", "true");
        // Add insurance product to cart
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: insuranceProductId,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Insurance added:", data);
            $(".cart_items").load(location.href + " .cart_items>*", "");
            $(".mini_cart_items").load(
              location.href + " .mini_cart_items>*",
              ""
            );
            // Update cart display logic here if needed
          })
          .catch((error) => {
            console.error("Error adding insurance:", error);
          });
      } else {
        localStorage.setItem("CheckInsurance", "false");
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: {
            quantity: 0,
            id: 48469609611555,
          },
          success: function (data) {
            $.ajax({
              type: "GET",
              dataType: "jsonp",
              url: "/cart.json",
              success: function (cart) {
                console.log("test area remove item", cart);
                $(".cart_items").load(location.href + " .cart_items>*", "");
                $(".mini_cart_items").load(
                  location.href + " .mini_cart_items>*",
                  ""
                );
                var item_count = cart["item_count"];
                var total_price = cart["total_price"] / 100;
              },
            });
          },
        });
      }
    });
  }
});
var priceText = $(".cart_tot_price span").text();
var numericPrice = priceText.replace(/[^0-9.-]+/g, ""); // Remove non-numeric characters
var total_price = parseFloat(numericPrice);
console.log("test area", total_price);
if (total_price >= 300) {
  $(".insurance-option").show();
} else {
  $(".insurance-option").hide();
}
$(document).on(
  "click",
  ".qty .plus, .qty .minus, .cart_ac_remove, .single_add_to_cart_button",
  function () {
    setTimeout(function () {
      var priceText = $(".cart_tot_price span").text();
      var numericPrice = priceText.replace(/[^0-9.-]+/g, ""); // Remove non-numeric characters
      var total_price = parseFloat(numericPrice);
      console.log("test area", total_price);
      if (total_price >= 300) {
        $(".insurance-option").show();
      } else {
        $(".insurance-option").hide();
      }
    }, 2500);
  }
);
